import React from 'react';

// AIDEV-NOTE: The SPA's page header band — title, optional actions, and the accent rule, flush
// on the --spa-bg ground so it top-aligns with the rail's header row. Raised surfaces (tables,
// cards, dialogs) carry the bg-secondary contrast; pages don't wrap content in a panel.
//
// On a content page the title is the page alone ("Table of Contents", "Lesson Guides"): the node
// it belongs to is named by the crumbs above and the rail, never repeated here.

interface SPAPageHeaderProps {
  actions?: React.ReactNode;
  className?: string;
  title: React.ReactNode;
}

const SPAPageHeader = ({ actions, className, title }: SPAPageHeaderProps) => (
  <div className={className}>
    <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3">
      <h2 className="tw-m-0 tw-text-2xl tw-font-bold tw-leading-tight tw-text-spa-heading [text-wrap:balance]">
        {title}
      </h2>
      {actions}
    </div>
    <hr className="tw-m-0 tw-mb-5 tw-mt-3.5 tw-border-0 tw-border-b-2 tw-border-solid tw-border-spa-accent" />
  </div>
);

export default SPAPageHeader;
